import { createContext } from "react";

export const TokenContext = createContext("TokenContext");
export const MailChimpWriteContext = createContext("MailChimpWriteContext");
